import {
  FormLabel,
  Grid,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { useProyecto } from "../../../data/ProyectoContext";
import { iProyectoABP } from "../../../interfaces/Proyecto/iProyecto";

const CompetenciasSigloXXI = () => {
  const { proyecto, setProyecto } = useProyecto();
  const handleCompetenciasSigloXXI = (event: SelectChangeEvent<string>) => {
    const CompetenciaSigloXXI = event.target.value;
    setProyecto((prevData) => ({
      ...prevData,
      competencias_siglo: CompetenciaSigloXXI,
    }));
  };

  return (
    <Grid item xs={12}>
      <Typography
        sx={{
          color: "#336B87",
          fontFamily: "montserrat",
          fontSize: "1.25rem",
          fontWeight: "bold",
        }}
      >
        Competencias del siglo XXI
      </Typography>
      <FormLabel
        component="p"
        sx={{
          fontFamily: "montserrat",
          m: 0,
          pb: 2,
          fontSize: "0.85rem",
        }}
      >
        Escoge las competencias que sean relevantes para tu tarea o actividad.
      </FormLabel>
      <Select
        fullWidth
        value={(proyecto as iProyectoABP).competencias_siglo}
        onChange={handleCompetenciasSigloXXI}
        displayEmpty
        placeholder="Selecciona una opción"
        variant="outlined"
        sx={{
          borderRadius: 2,
          fontFamily: "montserrat",
          mb: 2,
          fontSize: "14px",
          color: "#336B87",
          "& fieldset": { borderColor: "Divider" },
          "&:before": { borderColor: "Divider" },
          "&:after": { borderColor: "Divider" },
        }}
      >
        <MenuItem
          value="creatividad"
          sx={{ fontFamily: "montserrat", color: "#336B87" }}
        >
          Creatividad{" "}
        </MenuItem>
        <MenuItem
          value="caracter"
          sx={{ fontFamily: "montserrat", color: "#336B87" }}
        >
          {" "}
          Carácter
        </MenuItem>
        <MenuItem
          value="colaboracion"
          sx={{ fontFamily: "montserrat", color: "#336B87" }}
        >
          Colaboración
        </MenuItem>
        <MenuItem
          value="ciudadania"
          sx={{ fontFamily: "montserrat", color: "#336B87" }}
        >
          Ciudadanía
        </MenuItem>
        <MenuItem
          value="comunicacion"
          sx={{ fontFamily: "montserrat", color: "#336B87" }}
        >
          Comunicación
        </MenuItem>
        <MenuItem
          value="pensamientocritico"
          sx={{ fontFamily: "montserrat", color: "#336B87" }}
        >
          Pensamiento Crítico
        </MenuItem>
      </Select>
    </Grid>
  );
};

export default CompetenciasSigloXXI;
